import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';
import { useMotionValueEvent, useScroll, motion } from 'framer-motion';
import ButtonComponent from '../../atoms/Button/Button';
import RightArrow from '../../../app/assets/images/rightArrowBlue.svg';

interface ContactHelpProps {
    title: string,
    buttonTitle: string
}

const ContactHelp: FC<ContactHelpProps> = ({ title, buttonTitle }) => {
    const navigate = useNavigate();
    const { scrollYProgress } = useScroll();

    useMotionValueEvent(scrollYProgress, 'change', (latest) => {
    })

    return (
        <div className='flex items-center justify-center px-4 md:px-0'>
            <motion.div
                style={{
                    scaleX: scrollYProgress,
                    x: '0%',
                    y: '0%'
                }}
                data-aos="fade-up"
                className='flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 mt-8 md:mt-14 w-full sm:w-11/12 md:w-9/12 lg:w-6/12 mb-6 px-4 sm:px-6 md:px-8 lg:px-12 py-6 rounded-2xl bg-greyTernary'
            >
                <span className='text-white text-base sm:text-lg md:text-xl font-semibold text-center sm:text-left mb-4 sm:mb-0'>
                    {title}
                </span>
                <div className='relative flex-shrink-0'>
                    <ButtonComponent
                        iconClassName=""
                        iconPath={RightArrow}
                        labelClassname="text-white font-bold text-sm"
                        inputStyles={{
                            minWidth: '160px',
                            width: '160px',
                            height: '40px',
                            boxShadow: 'none',
                            '@media (min-width: 640px)': {
                                minWidth: '175px',
                                width: '175px'
                            },
                            '@media (min-width: 768px)': {
                                minWidth: '190px',
                                width: '190px'
                            }
                        }}
                        label={buttonTitle}
                        onClick={() => { navigate('/contactus') }}
                        
                    />
                </div>
            </motion.div>
        </div>
    )
}

export default ContactHelp